var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16H13C14.6569 16 16 14.6574 16 13.0005V6L10 0H3.00007C1.34322 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16Z",
    fill: "url(#paint0_linear_307_218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H3C1.48122 15.75 0.25 14.5188 0.25 13V3C0.25 1.48123 1.48128 0.25 3.00007 0.25H9.89645L15.75 6.10355V13.0005C15.75 14.5192 14.5188 15.75 13 15.75Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "url(#paint1_linear_307_218)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 6.4C9.79526 6.59526 9.79526 6.91185 9.6 7.10711L7.35356 9.35356C7.15829 9.54882 6.84171 9.54882 6.64645 9.35356C6.45119 9.1583 6.45119 8.84171 6.64645 8.64645L8.8929 6.4C9.08816 6.20474 9.40474 6.20474 9.6 6.4ZM5.35355 10.6465C5.54882 10.8417 5.54882 11.1583 5.35355 11.3536L3.10711 13.6C2.91185 13.7953 2.59526 13.7953 2.4 13.6C2.20474 13.4047 2.20474 13.0882 2.4 12.8929L4.64645 10.6465C4.84171 10.4512 5.15829 10.4512 5.35355 10.6465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83333 6.25C7.06345 6.25 7.25 6.43655 7.25 6.66667V8.75H9.33333C9.56345 8.75 9.75 8.93655 9.75 9.16667C9.75 9.39679 9.56345 9.58333 9.33333 9.58333H6.83333C6.60321 9.58333 6.41667 9.39679 6.41667 9.16667V6.66667C6.41667 6.43655 6.60321 6.25 6.83333 6.25ZM2.25 10.8333C2.25 10.6032 2.43655 10.4167 2.66667 10.4167H5.16667C5.39679 10.4167 5.58333 10.6032 5.58333 10.8333V13.3333C5.58333 13.5635 5.39679 13.75 5.16667 13.75C4.93655 13.75 4.75 13.5635 4.75 13.3333V11.25H2.66667C2.43655 11.25 2.25 11.0635 2.25 10.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_218",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_218",
    x1: 1,
    y1: 1,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0806874,
    stopColor: "#FFFE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155366,
    stopColor: "#FFFA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22496,
    stopColor: "#FFF507"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.290394,
    stopColor: "#FFED0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352593,
    stopColor: "#FFE413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41248,
    stopColor: "#FFD81B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470981,
    stopColor: "#FFCB24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529019,
    stopColor: "#FFBC2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58752,
    stopColor: "#FFAC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647407,
    stopColor: "#FF9A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709606,
    stopColor: "#FE8654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77504,
    stopColor: "#FE7262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844634,
    stopColor: "#FE5C71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919313,
    stopColor: "#FE4581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2D91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_218",
    x1: 13,
    y1: 3,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiFile);
export default __webpack_public_path__ + "static/media/api-file.032267900fb6ea358e8aae3f49bce4ba.svg";
export { ForwardRef as ReactComponent };